import useApi from '../utils/axios-pettitions';
import { newToast } from '../components';

export const useApiExternalRemisions = () => {
  const { runApi } = useApi();

  //#region Remisiones Externas
  
  /**
   * Obtener remisiones externas filtradas por fecha o id
   * @param inicio Fecha de inicio (opcional)
   * @param fin Fecha de fin (opcional)
   * @param id ID de la remisión (opcional)
   */
  const getByFilter = async (inicio?: Date | null, fin?: Date | null, id?: number | null) => {
    const params: any = {};
    if (inicio) params.inicio = inicio.toISOString();
    if (fin) params.fin = fin.toISOString();
    if (id) params.id = id;

    return runApi('ExternalRemisions/GetByFilter', 'GET', params, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  //#endregion

  //#region Laboratorios Remisiones Externas

  /**
   * Obtener todos los laboratorios externos
   */
  const getExternalLaboratories = async () => {
    return runApi('ExternalRemisions/GetExternalLaboratory', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  /**
   * Crear un nuevo laboratorio externo
   * @param data Datos del laboratorio externo
   */
  const createExternalLaboratory = async (data: any) => {
    return runApi('ExternalRemisions/CreateExternalLaboratory', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 101) {
        newToast('SUCCESS', res.message || 'Laboratorio creado correctamente', 3);
        return res.data;
      }
      return null;
    });
  };

  /**
   * Eliminar un laboratorio externo
   * @param id ID del laboratorio a eliminar
   */
  const deleteExternalLaboratory = async (id: number) => {
    return runApi('ExternalRemisions/DeleteExternalLaboratory', 'POST', { id }, null).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 101) {
        newToast('SUCCESS', res.message || 'Laboratorio eliminado correctamente', 3);
        return true;
      }
      return false;
    });
  };

  /**
   * Actualizar un laboratorio externo
   * @param data Datos del laboratorio a actualizar
   * @param id ID del laboratorio
   */
  const updateExternalLaboratory = async (data: any, id: number) => {
    return runApi('ExternalRemisions/UpdateExternalRemision', 'POST', { id }, data).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 101) {
        newToast('SUCCESS', res.message || 'Laboratorio actualizado correctamente', 3);
        return res.data;
      }
      return null;
    });
  };

  //#endregion

  return {
    // Remisiones Externas
    getByFilter,
    
    // Laboratorios Remisiones Externas
    getExternalLaboratories,
    createExternalLaboratory,
    deleteExternalLaboratory,
    updateExternalLaboratory,
  };
};
